import axios from "axios";

// const BaseDomin = "http://localhost:8000/"
// const BaseDomin = "http://41.129.128.162:8000/"
const BaseDomin = "https://apitarget.sinai-edu.com/"
// const BaseDomin = `${window.location.protocol}//${window.location.hostname}:8000/`;


let Api_Server = `${BaseDomin}api`

let Api = axios.create({
  baseURL: Api_Server,

});
export let Base = axios.create({
  baseURL: BaseDomin,

});




Api.defaults.withCredentials = true;
Base.defaults.withCredentials = true;

export default Api;



// let BaseApi = axios.create({
//   baseURL: "http://localhost:8000/api"
// });

// let Api = function() {
//   let token = localStorage.getItem("token");

//   if (token) {
//     BaseApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   }

//   return BaseApi;
// };

// export default Api;
